import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/i18n/title";
import { SettingsPage } from "@/support/SettingsPage";

export const Route = createFileRoute("/_authed/settings")({
  head: () => pageTitle("Settings"),
  component: SettingsPage,
});
